import { Select } from 'antd';
import { sortBy } from 'lodash';
import React, { useMemo } from 'react';
import { Capability } from '@mono/types/src/mds';

import { fuzzySearch } from '@mono/fuzzy-search';

interface CapabilitySelectorProps extends Pick<React.ComponentProps<typeof Select>, 'disabled' | 'onChange' | 'value' | 'loading'> {
    capabilities: Capability[];
    dataType: string | string[] | null;
}

const CapabilitySelector: React.FC<CapabilitySelectorProps> = ({ disabled, value, capabilities, onChange, dataType, loading }) => {
    const options = useMemo(() => {
        const filteredCapabilities = dataType ? capabilities.filter((c) => c !== undefined && dataType.includes(c.data_type)) : capabilities;
        return sortBy(filteredCapabilities, 'id').map((c) => {
            return (
                <Select.Option key={c.id} value={c.id}>
                    {c.display_name_short}
                </Select.Option>
            );
        });
    }, [dataType, capabilities.length]);

    return (
        <div style={{ width: '100%' }}>
            <Select
                value={value}
                style={{ width: '100%' }}
                showSearch
                allowClear
                optionFilterProp='children'
                filterOption={(input, option) => fuzzySearch(input.toLowerCase(), [option?.props.children?.toString().toLowerCase() || ''])}
                disabled={disabled}
                dropdownMatchSelectWidth={false}
                onChange={onChange}
                loading={loading}
            >
                {options}
            </Select>
        </div>
    );
};

export default CapabilitySelector;
export { CapabilitySelectorProps };
